import * as React from 'react'

export type AppContextValueType = {
  breadcrumb: string
  setBreadcrumb: React.Dispatch<React.SetStateAction<string>>
  editing: boolean
  setEditing: React.Dispatch<React.SetStateAction<boolean>>
  propertySetting: PropertySetting
  setPropertySetting: React.Dispatch<React.SetStateAction<PropertySetting>>
}

export const AppContext = React.createContext<AppContextValueType | undefined>(undefined)

export function useAppContext() {
  const store = React.useContext(AppContext)
  if (!store) {
    throw new Error('store is not defined')
  }
  return store
}

type AppProviderProps = {
  children: React.ReactNode
}

export type PropertySetting = {
  id: string
  phone: string
  marketing: string
}

export function AppProvider({ children }: AppProviderProps) {
  const [breadcrumb, setBreadcrumb] = React.useState<string>('The Keys on Third')

  const [editing, setEditing] = React.useState<boolean>(false)
  const [propertySetting, setPropertySetting] = React.useState<PropertySetting>({
    id: '1',
    phone: '12345677890',
    marketing:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temporincididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrudexercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis auteirure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa quiofficia deserunt mollit anim id est laborum.',
  })

  const value = React.useMemo(
    (): AppContextValueType => ({
      breadcrumb,
      setBreadcrumb,
      editing,
      setEditing,
      propertySetting,
      setPropertySetting,
    }),
    [breadcrumb, editing, propertySetting]
  )

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}
